/* Calendrier squishy · 4 lots : met à jour le prix affiché ([data-msp-prix]…) et ajoute N calendriers au tiroir panier Shrine (les remises automatiques font le prix du lot, en EUR comme en CHF) + le cadeau à 0 € dès le lot 2. */
class MspOffre extends HTMLElement {
  connectedCallback() {
    this.cartes = [...this.querySelectorAll('.mso__c')];
    this.btn = this.querySelector('.mso__btn'); this.err = this.querySelector('.mso__err');
    this.addEventListener('change', () => this.maj());
    this.btn.addEventListener('click', () => this.ajouter());
    this.maj();
  }
  get carte() { return this.cartes.find((c) => c.querySelector('input').checked) || this.cartes[0]; }
  maj() {
    const on = this.carte;
    this.cartes.forEach((c) => c.classList.toggle('is-on', c === on));
    const set = (sel, v) => document.querySelectorAll(sel).forEach((e) => (e.textContent = v));
    set('[data-msp-prix]', on.dataset.tot); set('[data-msp-barre]', on.dataset.bar); set('[data-msp-pct]', on.dataset.pct);
  }
  async ajouter() {
    this.btn.classList.add('is-load'); this.err.hidden = true;
    try {
      const items = [{ id: +this.dataset.v, quantity: +this.carte.dataset.n }], root = window.Shopify?.routes?.root || '/';
      // cadeau offert dès le lot 2 (variante à 0 €), une seule fois par panier
      if (this.dataset.cadeau && +this.carte.dataset.n > 1) {
        const panier = await (await fetch(`${root}cart.js`)).json();
        if (!panier.items.some((i) => i.variant_id === +this.dataset.cadeau)) items.push({ id: +this.dataset.cadeau, quantity: 1 });
      }
      const res = await fetch(`${root}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items, sections: 'cart-drawer,cart-icon-bubble', sections_url: location.pathname }) });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || 'Erreur');
      const d = document.querySelector('cart-drawer');
      if (d && typeof d.renderContents === 'function') { d.classList.remove('is-empty'); d.renderContents({ ...data, id: items[0].id }); }
      else location.href = `${root}cart`;
    } catch (e) { this.err.textContent = e.message; this.err.hidden = false; }
    finally { this.btn.classList.remove('is-load'); }
  }
}
if (!customElements.get('msp-offre')) customElements.define('msp-offre', MspOffre);
